import type { SshTarget } from '@voice-assistant/shared';
import { useSshTargets } from '../state/sshTerminalStore';

interface Props {
  open: boolean;
  targets: SshTarget[];
  onSelect: (targetId: string) => void;
  onClose: () => void;
}

export function SshTargetPicker({ open, targets: propTargets, onSelect, onClose }: Props) {
  // ssh-terminal-fsm-migration Phase 1 (read migration): render from the FSM store,
  // falling back to the legacy prop. The useSocket SSH_TARGETS handler dual-writes
  // both, so they are equivalent; the fallback hedges any store gap until Phase 2
  // makes the store authoritative. Hook MUST run before the early return below.
  const storeTargets = useSshTargets();
  const targets = storeTargets.length ? storeTargets : propTargets;

  if (!open) return null;

  return (
    <div class="ssh-picker-overlay" onClick={onClose}>
      <div class="ssh-picker" onClick={(e) => e.stopPropagation()}>
        <h3>Terminal</h3>
        {targets.length === 0 ? (
          <p class="ssh-picker-empty">No targets available</p>
        ) : (
          <div class="ssh-picker-list">
            {targets.map((t) => (
              <button
                key={t.id}
                class={`ssh-picker-item${t.id === 'local-0' ? ' local' : ''}`}
                onClick={() => { onSelect(t.id); onClose(); }}
              >
                <span class="ssh-picker-label">
                  {t.id === 'local-0' ? '>' : ''} {t.label}
                </span>
                <span class="ssh-picker-host">
                  {t.id === 'local-0' ? `${t.user} · /projects` : `${t.user}@${t.host}:${t.port}`}
                </span>
              </button>
            ))}
          </div>
        )}
        <button class="ssh-picker-cancel" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
